// getHasEnoughBalanceForGift.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getMeBalance from '../selector/getMeBalance.js';
import getGiftData from '../selector/getGiftData.js';

/**
 * Select has enough balance for gift by gift id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} giftId - gift id.
 * @param {number} count - gift count.
 * @return {boolean} should return true when user has enough balance to send gift.
 */
const getHasEnoughBalanceForGift = createCachedSelector(
  state => getMeBalance(state),
  (state, giftId) => getGiftData(state, giftId, 'price'),
  (state, giftId, count) => count,
  (balance, price, count = 1) => balance >= price * count
)((state, giftId, count) => `getHasEnoughBalanceForGift:${giftId}:${count}`);

export default getHasEnoughBalanceForGift;
